import { isFixtureMode } from '../routes/fixtureMode.js';

export const PAY_UNCONFIRMED =
  'We couldn’t confirm the change. Nobody is paid twice — press Pay anyway again to check what happened.';

export const PREVIEW_ONLY = 'Preview only · not saved. No change was sent.';
export function hasReceipt(value, status) {
  return typeof value?.receiptId === 'string' && value.receiptId.trim() !== '' && value.status === status;
}

/** Host resolves only AFTER persistence. Void, rejection and fixture mode never confirm a write. */
export async function persistWithReceipt(callback, args, status, matches = () => true) {
  if (isFixtureMode() || typeof callback !== 'function') return null;
  const receipt = await callback(...args);
  if (!hasReceipt(receipt, status) || !matches(receipt)) throw new Error('No matching persistence receipt');
  return receipt;
}
